// extracted by mini-css-extract-plugin
module.exports = {"pickup":"_7516","basic":"_13295","name":"_280","phoneNumber":"_2368","grow":"_19306","edit":"_10195","icon":"_4100","address":"_5600"};